import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db, googleProvider } from "../config/firebase";
import { signInWithPopup } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import "../App.css";
// Ensure loginHero is imported. userAuth uses ../assets/login_hero.png
import loginHero from "../assets/login_hero.png";
import AppIcon from "../assets/sayq-fav.svg";

export default function EventRegister() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [eventName, setEventName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // Add loading state

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password || !confirmPassword) {
      return setError("Wszystkie pola są wymagane.");
    }
    if (password !== confirmPassword) {
      return setError("Hasła muszą się zgadzać.");
    }

    setLoading(true);
    try {
      const response = await fetch("https://api18081113.queroapp.pl/register-event", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        navigate("/thank-you");
      } else {
        setError(data.error || "Rejestracja nie powiodła się.");
      }
    } catch (err) {
      console.error("Błąd:", err);
      setError("Błąd połączenia z serwerem.");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleRegister = async () => {
    setError("");

    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const res = await fetch("https://api18081113.queroapp.pl/google-auth", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: user.email, uid: user.uid })
      });
      const data = await res.json();

      if (data.success && data.secretId) {
        localStorage.setItem("authToken", "admin-logged-in");
        localStorage.setItem("secretId", data.secretId);
        // Direct jump to event wizard
        navigate(`/RegisterEvent/${data.secretId}`);
      } else {
        setError(data.error || "Autoryzacja po stronie serwera nie powiodła się.");
      }

    } catch (err) {
      console.error("Błąd logowania Google:", err);
      setError("Rejestracja przez Google nie powiodła się.");
    }
  };

  return (
    <div className="d-flex w-100 overflow-hidden bg-white font-sans page-root-fixed">
      {/* LEFT COLUMN: FORM */}
      <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center p-4 p-md-5 relative overflow-y-auto">
        <div className="w-100" style={{ maxWidth: "420px" }}>

          {/* Logo Placeholder */}
          <div className="mb-4 text-center text-md-start">
            <img src={AppIcon} alt="SayQ" className="rounded-3" style={{ width: 64, height: 64, objectFit: 'contain' }} />
          </div>

          <h1 className="fw-bold mb-2 text-dark" style={{ fontSize: '2rem' }}>Zacznij tutaj.</h1>
          <p className="text-secondary mb-5">Utwórz konto organizatora i prowadź lepsze eventy.</p>

          <form onSubmit={handleRegister}>
            <div className="mb-3">
              <label className="form-label text-uppercase small fw-bold text-secondary ls-1" style={{ fontSize: '0.7rem' }}>Adres E-mail</label>
              <input
                type="email"
                className="form-control form-control-lg bg-light border-0 rounded-3 py-3 px-3 transition-all focus-ring"
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="row g-3 mb-4">
              <div className="col-6">
                <label className="form-label text-uppercase small fw-bold text-secondary ls-1" style={{ fontSize: '0.7rem' }}>Hasło</label>
                <input
                  type="password"
                  className="form-control form-control-lg bg-light border-0 rounded-3 py-3 px-3 transition-all focus-ring"
                  placeholder="••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="col-6">
                <label className="form-label text-uppercase small fw-bold text-secondary ls-1" style={{ fontSize: '0.7rem' }}>Powtórz Hasło</label>
                <input
                  type="password"
                  className="form-control form-control-lg bg-light border-0 rounded-3 py-3 px-3 transition-all focus-ring"
                  placeholder="••••••"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </div>

            {error && (
              <div className="alert alert-danger py-2 text-center text-sm mb-4 rounded-3 border-0 bg-danger-subtle text-danger fw-bold animate-shake">
                {error}
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary w-100 btn-lg rounded-pill fw-bold py-3 mb-4 shadow-primary hover-lift transition-all"
              disabled={loading}
              style={{ fontSize: '0.9rem', letterSpacing: '0.5px' }}
            >
              {loading ? "Rejestrowanie..." : "ZAREJESTRUJ SIĘ"}
            </button>

            <div className="position-relative text-center mb-4">
              <hr className="text-secondary opacity-25" />
              <span className="position-absolute top-50 start-50 translate-middle bg-white px-3 text-muted small">lub</span>
            </div>

            <button
              type="button"
              onClick={handleGoogleRegister}
              className="btn btn-outline-light text-dark border border-2 w-100 rounded-pill py-3 fw-bold d-flex align-items-center justify-content-center gap-2 hover-bg-light transition-all"
            >
              <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="G" style={{ width: 20 }} />
              Zarejestruj przez Google
            </button>
          </form>

          <div className="mt-5 text-center">
            <span className="text-secondary small">Masz już konto? </span>
            <a href="#" onClick={(e) => { e.preventDefault(); navigate("/auth") }} className="text-primary fw-bold text-decoration-none small">
              Zaloguj się
            </a>
          </div>

        </div>
      </div>

      {/* RIGHT COLUMN: HERO IMAGE */}
      <div className="d-none d-md-block col-md-6 p-0 position-relative bg-dark overflow-hidden">
        <img
          src={loginHero}
          alt="Register Hero"
          className="w-100 h-100 object-fit-cover opacity-75 animate-zoom-slow"
          style={{ objectPosition: 'center' }}
        />
        <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)' }}></div>

        <div className="position-absolute bottom-0 start-0 w-100 p-5 mb-5 text-white">
          <h2 className="display-4 fw-bold mb-3">Twoje wydarzenie.<br />Na nowym poziomie.</h2>
          <p className="lead opacity-75" style={{ maxWidth: 400 }}>
            Od płynnej agendy po interakcje na żywo. Wszystko w jednym miejscu.
          </p>
        </div>
      </div>

      <style>{`
         .page-root-fixed { height: 100dvh; }
         .font-sans { font-family: 'Check', 'Inter', system-ui, -apple-system, sans-serif; }
         .ls-1 { letter-spacing: 1px; }
         
         .hover-lift:hover { transform: translateY(-2px); box-shadow: 0 10px 25px -5px rgba(37, 99, 235, 0.4); }
         .hover-bg-light:hover { background-color: #f8f9fa; border-color: #dee2e6 !important; }
         .shadow-primary { box-shadow: 0 4px 14px 0 rgba(37, 99, 235, 0.39); }
         .focus-ring:focus { box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1); background-color: #fff; border-color: var(--bs-primary); outline: none; }
         
         @keyframes zoomSlow { 0% { transform: scale(1); } 100% { transform: scale(1.05); } }
         .animate-zoom-slow { animation: zoomSlow 20s ease-in-out infinite alternate; }
         
         @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-5px); } 75% { transform: translateX(5px); } }
         .animate-shake { animation: shake 0.3s ease-in-out; }
      `}</style>
    </div>
  );
}
